// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"c24aa30a","802":"2aee435d"}[chunkId] + ".chunk.js";
};